/* Pawro — Product page engine (theme asset, loaded deferred by
   sections/pawro-product.liquid). Handles: variant selection with full-page
   atmosphere theming, price/stock sync, gallery (scroll-snap slides, thumbs,
   arrows, counter, zoom dialog, variant image sync), tabs, exclusive FAQ
   accordion, AJAX add-to-cart, and the mobile sticky bar. No libraries. */
(function () {
  if (window.__pawroPdp) return;
  window.__pawroPdp = true;

  function themeForColor(value) {
    var v = (value || '').toLowerCase();
    if (v.indexOf('pink') !== -1 || v.indexOf('rose') !== -1) return 'pink';
    if (v.indexOf('blue') !== -1 || v.indexOf('sky') !== -1) return 'blue';
    if (v.indexOf('green') !== -1 || v.indexOf('mint') !== -1 || v.indexOf('sage') !== -1) return 'green';
    if (v.indexOf('gold') !== -1 || v.indexOf('amber') !== -1 || v.indexOf('honey') !== -1 || v.indexOf('champagne') !== -1 || v.indexOf('yellow') !== -1) return 'gold';
    if (v.indexOf('grey') !== -1 || v.indexOf('gray') !== -1 || v.indexOf('graphite') !== -1) return 'gray';
    if (v.indexOf('lavender') !== -1 || v.indexOf('purple') !== -1 || v.indexOf('lilac') !== -1) return 'lavender';
    if (v.indexOf('white') !== -1 || v.indexOf('beige') !== -1 || v.indexOf('cream') !== -1 || v.indexOf('ivory') !== -1) return 'white';
    if (v.indexOf('orange') !== -1 || v.indexOf('tangerine') !== -1 || v.indexOf('coral') !== -1) return 'orange';
    if (v.indexOf('black') !== -1 || v.indexOf('onyx') !== -1 || v.indexOf('charcoal') !== -1) return 'black';
    return 'pink';
  }

  function init() {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;

    var dataEl = root.querySelector('[data-pdp-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants || [];
    var colorIndex = data.color_option_index; /* may be null */

    var form = root.querySelector('[data-pdp-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = root.querySelector('[data-pdp-qty]');
    var priceEls = root.querySelectorAll('[data-pdp-price]');
    var stockEl = root.querySelector('[data-pdp-stock]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var addLabel = root.querySelector('[data-pdp-add-label]');
    var stickyBar = root.querySelector('[data-pdp-sticky]');
    var stickyVariant = root.querySelector('[data-pdp-sticky-variant]');
    var lowStockMax = parseInt(root.getAttribute('data-low-stock') || '5', 10);

    /* ---------------- gallery ---------------- */
    var stage = root.querySelector('[data-pdp-stage]');
    var slides = stage ? Array.prototype.slice.call(stage.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var counter = root.querySelector('[data-pdp-counter]');
    var activeIndex = 0;

    /* scroll: false = update UI only (used by the scroll listener),
       'instant' = jump with no animation (first render),
       anything else = smooth glide (user interaction) */
    function setActiveSlide(index, scroll) {
      if (!slides.length) return;
      index = Math.max(0, Math.min(index, slides.length - 1));
      activeIndex = index;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        if (i === index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      if (scroll !== false) {
        stage.scrollTo({
          left: slides[index].offsetLeft,
          behavior: scroll === 'instant' ? 'auto' : 'smooth'
        });
      }
      /* pause any playing videos on slides we left */
      slides.forEach(function (slide, i) {
        if (i === index) return;
        slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
      });
    }

    /* which gallery slide belongs to a variant? (-1 when it has no image) */
    function slideIndexForVariant(variant) {
      if (!variant || !variant.featured_media_id) return -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(variant.featured_media_id)) return i;
      }
      return -1;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setActiveSlide(i); });
    });
    root.querySelectorAll('[data-pdp-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { setActiveSlide(activeIndex - 1); });
    });
    root.querySelectorAll('[data-pdp-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { setActiveSlide(activeIndex + 1); });
    });
    /* keep thumbs/counter in sync with native swipe */
    if (stage) {
      var scrollTimer = null;
      stage.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var nearest = 0;
          var best = Infinity;
          slides.forEach(function (slide, i) {
            var d = Math.abs(slide.offsetLeft - stage.scrollLeft);
            if (d < best) { best = d; nearest = i; }
          });
          if (nearest !== activeIndex) setActiveSlide(nearest, false);
        }, 90);
      }, { passive: true });
    }

    /* zoom dialog */
    var zoomDialog = root.querySelector('[data-pdp-zoom]');
    var zoomImg = zoomDialog ? zoomDialog.querySelector('img') : null;
    function openZoom() {
      if (!zoomDialog || !zoomImg) return;
      var slide = slides[activeIndex];
      var src = slide && slide.getAttribute('data-zoom-src');
      if (!src) return;
      /* keep the reserved aspect correct when this variant's image differs
         from the featured media whose dimensions are baked into the markup */
      var slideImg = slide.querySelector('img');
      if (slideImg && slideImg.naturalWidth) {
        zoomImg.width = slideImg.naturalWidth;
        zoomImg.height = slideImg.naturalHeight;
      }
      zoomImg.src = src;
      if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
    }
    root.querySelectorAll('[data-pdp-zoom-open]').forEach(function (btn) {
      btn.addEventListener('click', openZoom);
    });
    if (zoomDialog) {
      zoomDialog.addEventListener('click', function (event) {
        if (event.target === zoomDialog || event.target.hasAttribute('data-pdp-zoom-close')) zoomDialog.close();
      });
    }

    /* ---------------- variant selection ---------------- */
    var selected = (data.initial_options || []).slice();

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var o = 0; o < selected.length; o++) {
          if (variants[i].options[o] !== selected[o]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function applyVariant(variant, userTriggered) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      priceEls.forEach(function (el) { el.textContent = variant.price_formatted; });

      if (stockEl) {
        var html = '';
        if (!variant.available) {
          html = '<span class="pawro-pp__stock-dot pawro-pp__stock-dot--out"></span> Sold out';
        } else if (variant.inventory_managed && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockMax) {
          html = '<span class="pawro-pp__stock-dot"></span> In stock <em>· Only ' + variant.inventory_quantity + ' left!</em>';
        } else {
          html = '<span class="pawro-pp__stock-dot"></span> In stock';
        }
        stockEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available
            ? (addLabel.getAttribute('data-label') + ' — ' + variant.price_formatted)
            : 'Sold out';
        }
      }
      /* empty for single-variant products — Liquid deliberately sends ''
         so raw option junk like "1pc m" never reaches the customer */
      if (stickyVariant) stickyVariant.textContent = variant.title_short || '';

      /* whole-page atmosphere from the color value */
      if (colorIndex !== null && colorIndex !== undefined) {
        var nextTheme = themeForColor(variant.options[colorIndex]);
        var themeChanged = root.getAttribute('data-pdp-theme') !== nextTheme;
        root.setAttribute('data-pdp-theme', nextTheme);
        /* light sweep across the showcase while the palette crossfades */
        if (userTriggered && themeChanged) {
          root.classList.remove('is-theme-shift');
          void root.offsetWidth; /* restart the sweep animation */
          root.classList.add('is-theme-shift');
          window.clearTimeout(root.__pdpShiftTimer);
          root.__pdpShiftTimer = window.setTimeout(function () {
            root.classList.remove('is-theme-shift');
          }, 750);
        }
      }

      /* variant image sync — runs on first render too, so the hero and the
         active thumbnail always match the selected variant (jump instantly
         on load, glide when the customer picks a colour) */
      var target = slideIndexForVariant(variant);
      if (target !== -1 && target !== activeIndex) {
        setActiveSlide(target, userTriggered ? 'smooth' : 'instant');
      }

      /* keep the URL shareable */
      if (userTriggered && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-pdp-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optIndex = parseInt(btn.getAttribute('data-pdp-option'), 10);
        var value = btn.getAttribute('data-pdp-value');
        if (selected[optIndex] === value) return;
        selected[optIndex] = value;
        root.querySelectorAll('[data-pdp-option="' + optIndex + '"]').forEach(function (other) {
          var active = other === btn;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var label = root.querySelector('[data-pdp-option-label="' + optIndex + '"]');
        if (label) label.textContent = value;
        applyVariant(findVariant(), true);
      });
    });

    /* quantity stepper */
    root.querySelectorAll('[data-pdp-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-pdp-qty-step'), 10);
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = next;
      });
    });

    /* ---------------- add to cart (AJAX, graceful fallback) ---------------- */
    if (form && addBtn) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return; /* let it post normally */
        event.preventDefault();
        if (addBtn.classList.contains('is-adding')) return;
        addBtn.classList.add('is-adding');
        var original = addLabel ? addLabel.textContent : '';
        if (addLabel) addLabel.textContent = 'Adding...';
        var body = new FormData(form);
        /* Ask Shopify to also return the rendered cart-drawer section(s) so we
           can refresh the drawer in place. Without this, the theme's drawer keeps
           its page-load HTML (empty) until a full navigation — the reported bug. */
        var drawerIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
          if (c.dataset.sectionId && drawerIds.indexOf(c.dataset.sectionId) === -1) drawerIds.push(c.dataset.sectionId);
        });
        if (drawerIds.length) body.append('sections', drawerIds.join(','));

        fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
            return res.json();
          })
          .then(function (added) {
            if (addLabel) addLabel.textContent = 'Added to cart ✓';

            /* Hand the update to Horizon's own cart components instead of patching
               the DOM by hand. Both cart-icon.js and component-cart-items.js react
               ONLY inside `event.promise` (`event.promise?.then(({ cart, detail }) => …)`),
               so we dispatch the native cartLinesUpdate event carrying a promise that
               resolves to { cart, detail: { sections } }:
                 - cart-icon reads cart.totalQuantity  -> header bubble updates
                 - component-cart-items reads detail.sections[sectionId] and morphs
                   the drawer  -> items + summary render and the empty state clears
               Then we open the drawer so the customer sees the result. */
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                try {
                  var ev = new Event('shopify:cart:lines-update', { bubbles: true });
                  ev.action = 'add';
                  ev.detail = { source: 'pawro-pdp', itemCount: cart.item_count, sections: added && added.sections };
                  ev.promise = Promise.resolve({
                    cart: { totalQuantity: cart.item_count },
                    detail: { sections: added && added.sections, itemCount: cart.item_count }
                  });
                  document.dispatchEvent(ev);
                } catch (e) {}
                /* open the cart drawer for feedback (auto_open theme setting may be off) */
                try {
                  var drawer = document.querySelector('#cart-drawer');
                  if (drawer && typeof drawer.open === 'function') drawer.open();
                } catch (e) {}
              })
              .catch(function () {});
          })
          .catch(function (err) {
            if (addLabel) addLabel.textContent = err.message || 'Could not add';
          })
          .then(function () {
            window.setTimeout(function () {
              addBtn.classList.remove('is-adding');
              if (addLabel) addLabel.textContent = original;
            }, 2000);
          });
      });
    }
    root.querySelectorAll('[data-pdp-sticky-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }
      });
    });

    /* mobile sticky bar appears as soon as the main Add-to-cart button
       scrolls above the viewport (not when the whole panel clears — the
       panel is tall on mobile, which would delay the bar far too long) */
    var stickyAnchor = addBtn || root.querySelector('[data-pdp-panel]');
    if (stickyBar && stickyAnchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(stickyAnchor);
    }

    /* ---------------- showcase parallax (damped, desktop only) ----------------
       pointer position eases toward the cursor with a lerp, giving the hero
       image a weighted, spring-like tilt; ambient glows drift the opposite
       way for depth. Pure rAF + custom properties — 60fps, zero libraries. */
    var showcase = root.querySelector('.pawro-pp__stage-wrap');
    if (
      showcase &&
      window.matchMedia('(pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      var targetX = 0, targetY = 0, curX = 0, curY = 0, rafId = null;
      var settle = function () {
        curX += (targetX - curX) * 0.09;
        curY += (targetY - curY) * 0.09;
        root.style.setProperty('--ppx', curX.toFixed(2) + 'px');
        root.style.setProperty('--ppy', curY.toFixed(2) + 'px');
        if (Math.abs(targetX - curX) > 0.05 || Math.abs(targetY - curY) > 0.05) {
          rafId = window.requestAnimationFrame(settle);
        } else {
          rafId = null;
        }
      };
      var wake = function () {
        if (!rafId) rafId = window.requestAnimationFrame(settle);
      };
      showcase.addEventListener('pointermove', function (event) {
        var r = showcase.getBoundingClientRect();
        targetX = ((event.clientX - r.left) / r.width - 0.5) * 10;
        targetY = ((event.clientY - r.top) / r.height - 0.5) * 8;
        wake();
      });
      showcase.addEventListener('pointerleave', function () {
        targetX = 0;
        targetY = 0;
        wake();
      });
    }

    /* ---------------- tabs ---------------- */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-tab-panel]'));
    function selectTab(id) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-pdp-tab') === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-pdp-tab-panel') !== id;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectTab(tab.getAttribute('data-pdp-tab')); });
      tab.addEventListener('keydown', function (event) {
        var dir = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        event.preventDefault();
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        next.focus();
        selectTab(next.getAttribute('data-pdp-tab'));
      });
    });

    /* ---------------- exclusive FAQ accordion ---------------- */
    root.addEventListener('toggle', function (event) {
      var opened = event.target;
      if (!opened.hasAttribute || !opened.hasAttribute('data-pdp-faq') || !opened.open) return;
      root.querySelectorAll('[data-pdp-faq][open]').forEach(function (other) {
        if (other !== opened) other.open = false;
      });
    }, true);

    /* ---------------- boot ----------------
       Everything initialises from the variant Shopify actually selected
       (first available, or the ?variant= deep link) — never from a
       hardcoded slide. If that variant has no image of its own we fall
       back to the first slide. */
    var bootVariant = findVariant();
    var bootIndex = slideIndexForVariant(bootVariant);
    setActiveSlide(bootIndex === -1 ? 0 : bootIndex, 'instant');
    applyVariant(bootVariant, false);

    /* images finish loading after first paint; re-assert the position so a
       late layout shift can't leave the stage parked on the wrong slide */
    window.addEventListener('load', function () {
      var idx = slideIndexForVariant(findVariant());
      if (idx !== -1) setActiveSlide(idx, 'instant');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
